export default __webpack_public_path__ + "static/media/aboutImage.f13c1953.png";